import { Button, Icon, Text } from "@ttc3k/trekker";
import { PageAction } from "shared/components/organisms/PageActions";
import { css } from "styled-system/css";

type PageActionItemProps = {
  action: PageAction;
  disabled?: boolean;
  isLoading?: boolean;
  onClick: (key: string) => void;
};

export const PageActionItem = ({
  action,
  disabled,
  isLoading,
  onClick,
}: PageActionItemProps) => (
  <Button
    visual="unstyled"
    display={"flex"}
    flexDir="row"
    justifyContent={"flex-start"}
    alignItems={"center"}
    gap="100"
    rounded="25"
    onClick={() => onClick(action.key)}
    {...{
      opacity: action.buttonOpacity ? action.buttonOpacity : 1,
    }}
    disabled={isLoading || disabled}
    className={css({
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.5,
      },
    })}
  >
    {action.useAlternateInfo && action.alternateInfo?.Icon ? (
      <Icon Element={action.alternateInfo.Icon} color="icon.mid" />
    ) : (
      action.Icon && <Icon Element={action.Icon} color="icon.mid" />
    )}
    <Text>
      {action.useAlternateInfo && action.alternateInfo?.text
        ? action.alternateInfo.text
        : action.text}
    </Text>
  </Button>
);
